import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-cyber.mp4';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/cloud-image.png';
import './IntroSectionCyberData.css';

const IntroSectionCyberData2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-cyber-data-2">
      {/* Video and Images Section */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('dataCyber.introSection.dataLeaks.title')}</h2>
            <h3>{t('dataCyber.introSection.dataLeaks.description')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('common.videoNotSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('dataCyber.introSection.consequences.title')}</h2>
            <h3>{t('dataCyber.introSection.consequences.description')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={DatacenterImage}
              alt={t('dataCyber.introSection.consequences.imageAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('dataCyber.introSection.partner.title')}</h2>
              <h3>{t('dataCyber.introSection.partner.description1')}</h3>
              <h3>{t('dataCyber.introSection.partner.description2')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('dataCyber.introSection.partner.imageAlt', 'Azure OpenAI')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionCyberData2;
